import { useEffect, useState } from "react";
import CategorySelectModal from "../Modals/CategorySelectModal";
import "../../style/scss/tree.scss";

export default function TreeView(props) {
  const [selectedID, setSelected] = useState(0);
  const [treeOpen, setTreeOpen] = useState(false);

  const categoryId =
    props.formObject?.object?.[props.field] ??
    props.formObject?.object?.[
      props.field ? props.field.charAt(0).toLowerCase() + props.field.slice(1) : ""
    ] ??
    0;

  const displayName =
    props.formObject?.object?.[props.fieldDisplay] ||
    props.formObject?.object?.[
      props.fieldDisplay
        ? props.fieldDisplay.charAt(0).toLowerCase() + props.fieldDisplay.slice(1)
        : ""
    ] ||
    (selectedID || categoryId ? `Category #${selectedID || categoryId}` : "");

  useEffect(() => {
    const nextId = Number(categoryId) || 0;
    if (nextId !== selectedID) setSelected(nextId);
  }, [categoryId]);

  const openTree = (e) => {
    e?.stopPropagation();
    setTreeOpen(true);
  };

  const onSelect = ({ id, name }) => {
    setSelected(id);
    if (props.formObject?.onChange) {
      props.formObject.onChange(id, props.field, "CategorySelect");
      if (props.fieldDisplay) {
        props.formObject.onChange(name, props.fieldDisplay, "CategorySelect");
      }
    }
  };

  return (
    <div className="field TreeView form-group">
      {props.label ? (
        <label className="form-label" htmlFor={`treeview-${props.field}`}>
          {props.label}
        </label>
      ) : null}
      <button
        type="button"
        id={`treeview-${props.field}`}
        className="form-input treeview-trigger"
        data-testid="treeview-category-trigger"
        onClick={openTree}
      >
        {displayName || "Select category…"}
      </button>
      <CategorySelectModal
        open={treeOpen}
        onClose={() => setTreeOpen(false)}
        onSelect={onSelect}
        getData={props.getData}
        selectedId={selectedID || categoryId}
        title={props.label || "Select category"}
      />
    </div>
  );
}
